var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86627 2.80022C1.86627 1.70486 2.75424 0.816895 3.8496 0.816895H10.1497C11.2451 0.816895 12.1331 1.70489 12.1331 2.80027L12.1329 11.2003C12.1329 12.2956 11.2449 13.1836 10.1496 13.1836L3.84954 13.1835C2.75417 13.1835 1.8662 12.2956 1.86621 11.2002L1.86627 2.80022ZM3.8496 1.98356C3.39857 1.98356 3.03293 2.34919 3.03293 2.80022L3.03288 11.2002C3.03287 11.6512 3.39851 12.0169 3.84954 12.0169L10.1496 12.0169C10.6006 12.0169 10.9662 11.6513 10.9662 11.2002L10.9664 2.80024C10.9664 2.34921 10.6008 1.98356 10.1497 1.98356H3.8496ZM4.31643 4.20023C4.31643 3.87806 4.5776 3.61689 4.89976 3.61689H9.09976C9.42193 3.61689 9.68309 3.87806 9.68309 4.20023C9.68309 4.52239 9.42193 4.78356 9.09976 4.78356H4.89976C4.5776 4.78356 4.31643 4.52239 4.31643 4.20023ZM4.31643 6.30023C4.31643 5.97806 4.5776 5.71689 4.89976 5.71689H9.09976C9.42193 5.71689 9.68309 5.97806 9.68309 6.30023C9.68309 6.62239 9.42193 6.88356 9.09976 6.88356H4.89976C4.5776 6.88356 4.31643 6.62239 4.31643 6.30023ZM4.31643 8.40023C4.31643 8.07806 4.5776 7.81689 4.89976 7.81689H6.99976C7.32193 7.81689 7.5831 8.07806 7.5831 8.40023C7.5831 8.72239 7.32193 8.98356 6.99976 8.98356H4.89976C4.5776 8.98356 4.31643 8.72239 4.31643 8.40023Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.72d76d12fc1726a9c03ca2cbdd1160a3.svg";
export { ForwardRef as ReactComponent };